import type { Components, Theme } from "@mui/material/styles";

export const MuiSwitch: Components<Theme>["MuiSwitch"] = {
  defaultProps: {
    color: "primary",
  },
  styleOverrides: {
    // the default medium switch is 38px high; this makes it 40px
    sizeMedium: ({ theme }) => ({
      height: theme.spacing(5),
      padding: theme.spacing(1.625, 1.5),
      "& .MuiSwitch-switchBase": {
        padding: theme.spacing(1.25),
      },
    }),
  },
};
